// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-wishlist." + {"31":"6415d392f27b3e15","367":"351f5aa601b32a81","412":"6dac4340906df70a","543":"0cd6ce6b09f9261a","667":"52f9b57f952cd426","755":"2b0f22c61c3f468b","775":"01c54f40944540ce"}[chunkId] + ".js";
};